var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.show_SEM_placeholder_check)?_c('div',[_c('LogoRow'),_c('TabContainer')],1):_vm._e(),(_vm.show_SEM_placeholder_check)?_c('div',{staticClass:"placeholder"},[_c('Placeholder')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }